module.exports = __webpack_public_path__ + "img/categorie-crustaces-famille-boutrais.8760c7c5.jpg";